<template>
  <div class="time">
    {{ date }}
  </div>
</template>

<script>
export default {
  name: "ms",
  props: {
    time: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      date: null,
      timer: null,
    };
  },
  mounted() {
    this.date = this.time;
    // this.countDown();
  },
  methods: {
    countDown() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.date > 0) {
          this.date--;
          this.$emit("change", this.date);
        } else {
          clearInterval(this.timer);
          this.$emit("success");
        }
      }, 1000);
    },
  },
  watch: {
    time: {
      immediate: true,
      handler(val) {
        this.date = val;
        this.countDown();
      },
    },
  },

  filters: {
    dateFormat(date) {
      let obj = {};
      obj.h = parseInt(date / 3600);
      obj.f = parseInt((date - obj.h * 3600) / 60);
      obj.m = parseInt(date - obj.h * 3600 - obj.f * 60);

      if (obj.h < 10) {
        obj.h = "0" + obj.h;
      }
      if (obj.f < 10) {
        obj.f = "0" + obj.f;
      }
      if (obj.m < 10) {
        obj.m = "0" + obj.m;
      }

      return `${obj.h}:${obj.f}:${obj.m}`;
    },
  },
};
</script>

<style>
</style>